import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Scrollbars from "react-custom-scrollbars";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DownIcon = ({ footerHeight, scrollBarsRef }) => {
  return (
    <OverlayTrigger
      delay={700}
      overlay={<Tooltip>More To See!</Tooltip>}
      placement="left"
    >
      <div
        className="more-to-see"
        style={{ bottom: `calc(1rem + ${footerHeight || 0}px)` }}
        onClick={() => {
          const current = scrollBarsRef.getScrollTop();
          const height = scrollBarsRef.getClientHeight();
          scrollBarsRef.scrollTop(current + height);
        }}
      >
        <FontAwesomeIcon icon={["fal", "arrow-down"]} />
      </div>
    </OverlayTrigger>
  );
};

const FullHeight = ({ children, id, className, footerHeight, style = {} }) => {
  if (footerHeight) {
    style.paddingBottom = `calc(1rem + ${footerHeight}px)`;
  }
  const ref = useRef();
  const [seeMore, setSeeMore] = useState(false);
  return (
    <div
      id={id}
      className={`${className || ""} full-height-page`}
      style={style}
    >
      <Scrollbars
        // autoHide
        ref={ref}
        renderView={(props) => (
          <div
            {...props}
            className="react-scrollbars-view p-4"
            id={id + "ScrollBar"}
          />
        )}
        onUpdate={({ clientHeight, scrollHeight, scrollTop }) => {
          const more = scrollHeight - clientHeight > scrollTop;
          if (more !== seeMore) setSeeMore(more);
        }}
      >
        {children}
      </Scrollbars>
      {seeMore && (
        <DownIcon scrollBarsRef={ref?.current} footerHeight={footerHeight} />
      )}
    </div>
  );
};

export default FullHeight;
